/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".debit-order-detail-table[_ngcontent-%COMP%]{font-size:12px;margin-left:60px}.debit-order-detail-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{font-size:12px}.debit-order-detail-table[_ngcontent-%COMP%]   td.right-align[_ngcontent-%COMP%]{text-align:right}.debit-order-detail-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-weight:700}"];
export { styles as styles };
